(function() {
  if (window.__decrumWebbotifyLoaderBound) return;
  window.__decrumWebbotifyLoaderBound = true;

  function loadWebbotifyChat() {
    if (window.__decrumWebbotifyLoaded) return;
    if (typeof window.decrumLoadWebbotifyChat === 'function') {
      window.decrumLoadWebbotifyChat();
      return;
    }
    if (document.querySelector('script[data-webbotify-chat="true"]')) {
      window.__decrumWebbotifyLoaded = true;
      return;
    }

    window.__decrumWebbotifyLoaded = true;
    var script = document.createElement('script');
    script.src = 'https://api2.webbotify.com/chat/5552121602112499810718109.js';
    script.async = true;
    script.defer = true;
    script.setAttribute('data-webbotify-chat', 'true');
    document.head.appendChild(script);
  }

  function bindDeferredLoad() {
    if (window.__decrumWebbotifyTriggersBound) return;
    window.__decrumWebbotifyTriggersBound = true;

    var triggered = false;
    var triggerLoad = function() {
      if (triggered) return;
      triggered = true;
      loadWebbotifyChat();
    };

    var events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    events.forEach(function(eventName) {
      window.addEventListener(eventName, triggerLoad, { once: true, passive: true });
    });
  }

  window.decrumLoadWebbotifyChat = loadWebbotifyChat;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDeferredLoad, { once: true });
  } else {
    bindDeferredLoad();
  }
})();
 